import {ApplicationInsights} from '@microsoft/applicationinsights-web'
import {ReactPlugin} from '@microsoft/applicationinsights-react-js'
import get from 'lodash/get'

export const addTelemetryInitializers = (appInsights) => {
  const domainsToIgnore = ['split.io', 'walkme.com']
  domainsToIgnore.forEach((domain) =>
    appInsights.addTelemetryInitializer((envelope) => {
      return !get(envelope, 'baseData.target', '').includes(domain)
    })
  )
}

const instrumentationKeys = {
  'dev': 'd2c083c3-d392-4f32-9aa3-5f85eb56f344',
  'test': 'd2c083c3-d392-4f32-9aa3-5f85eb56f344',
  'stage': 'd2c083c3-d392-4f32-9aa3-5f85eb56f344',
  'live': '237e5e94-131c-4d29-9f7e-2235ad37796c',
}

const initTracking = (env, history) => {
  let appInsights
  var instrumentationKey = instrumentationKeys[env]
  var reactPlugin = new ReactPlugin()
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: instrumentationKey,
      disableFetchTracking: false,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: {history: history},
      },
    },
  })
  appInsights.loadAppInsights()
  addTelemetryInitializers(appInsights)
  return appInsights
}

export default initTracking



// WEBPACK FOOTER //
// ./src/tracking.js